import * as types from "../mutation-type";
import util from "../../utils";

const state = {
  loading: false,
};

const actions = {
  setLoding ( { commit }, val ) {
    commit( types.SET_LOADING, val );
  },
  logout () {
    util.removeStore( 'token' )
    util.removeStore( 'userId' )
    util.removeStore( 'userType' )
  }
};

const getters = {
  loading: ( state ) => state.loading
};

const mutations = {
  [types.SET_LOADING] ( state, val ) {
    state.loading = val;
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
};
